const useAuthStudent = () => {
  const localAuth = localStorage.getItem("auth");
  if (localAuth) {
    const auth = JSON.parse(localAuth);
    if (auth.accessToken && auth.user && auth.user.role === "student") {
      return true;
    }
    return false;
  }
};

export default useAuthStudent;
